import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  content: {
    display: 'flex',
    gap: `${theme.spacing(5)} !important`,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  leftColumn: {
    width: theme.spacing(62.5),
    flexShrink: 0,
    minHeight: 0,
  },
  verticalDivider: {
    width: theme.spacing(0.125),
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: theme.spacing(0.5),
    background: theme.palette.dividerV2.main,
  },
  videoContainer: {
    position: 'relative',
    width: theme.spacing(46.875),
    height: theme.spacing(26.375),
    margin: '0 auto',
  },
  thumbnailImages: {
    width: theme.spacing(46.875),
    height: theme.spacing(26.375),
    display: 'block',
    cursor: 'pointer',
    borderRadius: theme.spacing(0.5),
  },
  sectionText: {
    fontSize: theme.spacing(1.75),
    fontStyle: 'regular',
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    marginBottom: theme.spacing(4),
  },
  videoWrapper: {
    width: theme.spacing(50.875),
    flexShrink: 0,
    backgroundColor: theme.palette.textBackground.light,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2, 2, 2, 2),
    gap: theme.spacing(2),
    borderRadius: theme.spacing(1),
    maxHeight: theme.spacing(35.375),
    boxSizing: 'border-box',
  },
  playButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    width: '44px',
    height: '44px',
    border: 'none',
    boxSizing: 'border-box',
    opacity: '0.24',
    backgroundColor: theme.palette.black.dark,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  playIcon: {
    color: theme.palette.text.white,
  },
  dataFeedsSection: {
    height: 'auto',
    width: '100%',
  },
  dataFeedsSectionMarginYes: {
    marginTop: theme.spacing(2),
  },
  dataFeedsSectionMarginNo: {
    marginTop: theme.spacing(2),
  },
  stackTypeRadioContainer: {
    width: '100%',
    maxWidth: theme.spacing(129),
    marginTop: theme.spacing(1),
  },
  stackTypeRadioGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(3),
    width: '100%',
  },
  stackTypeRadioItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(63),
    height: theme.spacing(6),
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.textBackground.light,
    boxSizing: 'border-box',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
    },
    '& .MuiFormControlLabel-label': {
      marginLeft: 0,
      marginRight: 0,
      padding: 0,
      fontSize: theme.spacing(1.75),
      fontWeight: 400,
      lineHeight: theme.spacing(2.5),
      letterSpacing: '0.25px',
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,
    },
    '& .MuiRadio-root': {
      padding: 0,
    },
  },
  dataFeedsQuestionContainer: {
    height: theme.spacing(7.5),
    width: theme.spacing(129),
    marginTop: theme.spacing(1),
  },
  radioGroupWrapper: {
    marginTop: theme.spacing(2),
  },
  stackSectionWrapper: {
    height: 'auto',
    width: '100%',
  },
  arnSectionWrapper: {
    height: 'auto',
    width: '100%',
  },
  sectionHeadingPlatformRole: {
    height: theme.spacing(3.375),
    width: theme.spacing(19.75),
    fontWeight: 500,
    fontStyle: 'medium',
    fontSize: theme.spacing(2.25),
    lineHeight: theme.spacing(3.375),
    letterSpacing: '0%',
    marginBottom: theme.spacing(3),
  },
  sectionHeadingDataFeeds: {
    height: theme.spacing(3.375),
    width: theme.spacing(12.375),
    fontWeight: 500,
    fontStyle: 'medium',
    fontSize: theme.spacing(2.25),
    lineHeight: theme.spacing(3.375),
    letterSpacing: '0%',
    marginBottom: theme.spacing(3),
  },
  videoColumn: {
    width: theme.spacing(56.375),
    height: theme.spacing(35.375),
  },
  videoLinkContainer: {
    width: theme.spacing(24.125),
    height: theme.spacing(3),
    borderRadius: theme.spacing(0.5),
    gap: theme.spacing(1),
  },
  subHeading: {
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.spacing(1.75),
    fontStyle: 'regular',
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.25px',
    marginBottom: theme.spacing(3),
  },
  downloadTerraformStackRow: {
    display: 'flex-start',
    marginTop: theme.spacing(1.5),
    marginBottom: '-0.5px',
  },
  downloadTerraformStackLink: {
    color: theme.palette.select.light,
    fontWeight: 500,
    textTransform: 'none',
  },
  headingSectionTextContainer: {
    marginBottom: theme.spacing(1),
  },
  headingSectionText: {
    fontSize: theme.spacing(1.75),
    fontStyle: 'regular',
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    width: theme.spacing(129),
    marginTop: theme.spacing(1),
    '& [data-testid="action-link"]': {
      color: theme.palette.select.light,
      fontWeight: 500,
    },
    marginBottom: theme.spacing(1),
    height: 'auto',
  },
  downloadIcon: {
    color: theme.palette.icon.blue,
  },
  download: {
    height: '21px',
    width: '19px',
    fontSize: '16px',
    marginRight: '4px',
    marginTop: '12px',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  headingSectionTextTerraform: {
    marginTop: '36px',
  },
  stepHeading: {
    display: 'flex',
    alignItems: 'center',
  },
  stepLabel: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    marginLeft: theme.spacing(1),
  },
  personaSection: {
    marginTop: theme.spacing(0.25),
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
  personaVerticalDivider: {
    width: theme.spacing(0.125),
    height: theme.spacing(3.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    background: theme.palette.dividerV2.main,
    marginRight: theme.spacing(0.75),
  },
}))
